import { flow } from 'lodash';
import { takeLatest, put, select, delay, call } from 'redux-saga/effects';

import getApiFeesService from '@giro/shared-services/pdv/getApiFees.service';
import getApiLinkFeesService from '@giro/shared-services/pdv/getApiLinkFees.service';

import toaster from '@giro/shared-store/toaster';

import currentStore from '.';

function* handleServiceGet() {
  const showToaster = flow(toaster.action.show, put);

  yield put(currentStore.action.fetchStart());

  try {
    const [success, result] = yield call(getApiFeesService);

    if (!success) {
      throw result;
    }

    yield put(currentStore.action.fetchSuccess(result));
  } catch (e) {
    yield showToaster({
      message: 'Aconteceu um erro, tente novamente mais tarde',
      variant: 'error',
    });
  }
}

function* handleServiceGetLink() {
  const showToaster = flow(toaster.action.show, put);

  yield put(currentStore.action.fetchStart());

  try {
    const [success, result] = yield call(getApiLinkFeesService);

    if (!success) {
      throw result;
    }

    yield put(currentStore.action.fetchSuccessLink(result));
  } catch (e) {
    yield showToaster({
      message: 'Aconteceu um erro, tente novamente mais tarde',
      variant: 'error',
    });
  }
}

function* watch() {
  yield takeLatest(
    currentStore.constant.ACTION_TYPES.SERVICE.GET,
    handleServiceGet
  );

  yield takeLatest(
    currentStore.constant.ACTION_TYPES.SERVICE.GET_LINK,
    handleServiceGetLink
  );
}

export default {
  watch,
};
